import OmnitureHelper from '.';

function errorMessage (msg) {
  this.payload.prop18 = msg;
  return this;
}

// returns a copy of the payload and resets it
function build () {
  const data = Object.assign({}, this.payload);
  this.payload = {};
  return data;
}

function send (newOptions) {
  OmnitureHelper.send(this.build(), newOptions);
  return this;
}

function sendSingle () {
  OmnitureHelper.sendSingle(this.build());
  return this;
}

function reCaptchaPageView () {
  this.payload.events = 'event15';
  return this;
}

function tmLinksNavlink (str) {
  this.payload.linkTrackVars = 'prop14,eVar14';
  this.payload.prop14 = str;
  return this;
}

function clear () {
  this.payload = {};
  return this;
}

export default  {
  payload: {},
  clear: clear,
  tmLinksNavlink: tmLinksNavlink,
  errorMessage: errorMessage,
  build: build,
  send: send,
  sendSingle: sendSingle,
  reCaptchaPageView: reCaptchaPageView
};



// WEBPACK FOOTER //
// ./frontend/react/utils/omniture-helper/omniture_builder.js